import httpClient from './http-clients/portaljad'

const baseUrl = 'layout-parametro'

export default class LayoutParametroService {
  static async findAll() {
    try {
      const { data } = await httpClient.get(baseUrl)
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }

  static async findAllReversa() {
    try {
      const { data } = await httpClient.get([baseUrl, 'reversa'].join('/'))
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }
}